import React from 'react';
import { useHistory } from 'react-router-dom';
import API from 'utils/api';
import Header from 'components/Header';
import { Card, Button, Icon, List, Statistic } from 'semantic-ui-react';
import authHelpers from 'utils/authHelpers';

function MicroAccountPage() {
  const [userInformation, setUserInformation] = React.useState(null);
  const history = useHistory();
  
  React.useEffect(() => {
    API.getMicroAccount()
      .then((response) => {
        setUserInformation(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleLogout = () => {
    authHelpers.logout();
    history.push('/');
  };

  if (!userInformation || !userInformation.created_at) {
    return (
      <div style={{ padding: '2em', textAlign: 'center' }}>
        <Icon loading name='spinner' size='large' />
        <p>Cargando información...</p>
      </div>
    );
  }

  const today = new Date();
  const formattedDate = new Intl.DateTimeFormat('es-ES', { 
    day: 'numeric',
    month: 'long'
  }).format(today);

  return (
    <div>
      <Header 
        text="Tu Perfil"
        subtitle={formattedDate}
      />
      
      {/* Profile Section */}
      <Card fluid style={{ boxShadow: 'none', border: 'none', borderBottom: '1px solid #eee', marginTop: '1.5em' }}>
        <Card.Content style={{ padding: '16px 8px' }}>
          <List>
            <List.Item style={{ marginBottom: '16px' }}>
              <List.Icon name='user' size='large' style={{ color: '#666' }} />
              <List.Content>
                <List.Header style={{ fontSize: '1.1em', color: '#666', marginBottom: '4px' }}>Nombre</List.Header>
                <List.Description style={{ fontSize: '1.4em', fontWeight: 'bold' }}>{userInformation.name}</List.Description>
              </List.Content>
            </List.Item>
            <List.Item style={{ marginBottom: '16px' }}>
              <List.Icon name='mail' size='large' style={{ color: '#666' }} />
              <List.Content>
                <List.Header style={{ fontSize: '1.1em', color: '#666', marginBottom: '4px' }}>Correo</List.Header>
                <List.Description style={{ fontSize: '1.4em', fontWeight: 'bold' }}>{userInformation.email}</List.Description>
              </List.Content>
            </List.Item>
          </List>
        </Card.Content>
      </Card>

      {/* Logout Button */}
      <Button 
        fluid 
        size="large"
        onClick={handleLogout}
        style={{ 
          marginTop: '24px',
          marginBottom: '24px',
          height: '54px',
          borderRadius: '8px',
          fontSize: '1.1em',
          fontWeight: 'bold',
          boxShadow: 'none',
          backgroundColor: '#db2828',
          color: 'white'
        }}
      >
        cerrar sesión
      </Button>
    </div>
  );
}

export default MicroAccountPage;

